.feature-group-section {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
}
